import React from 'react';
import { useHistory } from 'react-router';
import { useOnMount } from '@chaser/components';
import LoadingMessage from '../../components/LoadingMessage';
import AuthenticationService from '../../services/authentication-service';
import usePush from '../../hooks/usePush';
import useUser from '../../hooks/useUser';

const LoginXero = () => {
  const { isLoggedIn } = useUser();
  const { execute } = usePush(AuthenticationService.loginXero);
  const history = useHistory();

  async function login() {
    const [err, res] = await execute();

    if (err) {
      history.push('/login', {
        loginError: 'Sorry. The system was not able to authenticate using Xero.',
      });
      return;
    }

    const { url } = res;
    window.location.replace(url);
  }

  useOnMount(() => {
    if (isLoggedIn) {
      history.replace('/');
    } else {
      login();
    }
  });

  return <LoadingMessage center useLogoAnimation />;
};

export default LoginXero;
